import { Outlet } from "react-router-dom";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { EmailCapture } from "./EmailCapture";

export const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col" style={{ background: "var(--sss-bg)" }}>
            <AnnouncementBar />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <CartDrawer />
            <EmailCapture />
        </div>
    );
};
